export enum YesOrNo {
  Y = 'Y',
  N = 'N',
}

// API Models

export interface ApiUsStateResponse {
  lookupCode: string;
  lookupDescription: string;
}

export interface ApiProductGroupHcpcsResponse {
  productGroupName: string;
  groupHcpcsCodes: string[];
}

export interface ApiInsuranceTypeReportGroupsResponse {
  insuranceTypeId: number;
  insuranceTypeName: string;
  insuranceReportGroups: string[];
}

// Front End Models

export interface Name {
  firstName: string;
  lastName: string;
  fullName: string;
  initials: string;
}

export interface UsState {
  value: string; // ex: AK
  name: string; // ex: Alaska
}

export interface ProductGroupHcpcs extends ApiProductGroupHcpcsResponse {}

export interface InsuranceTypeReportGroups extends ApiInsuranceTypeReportGroupsResponse {}

// Mappers

export const mapName = (first?: string | null, last?: string | null): Name => {
  const firstName = first || '';
  const lastName = last || '';
  const initials = `${first ? first.charAt(0) : ''}${last ? last.charAt(0) : ''}`;
  const fullName = `${first || ''}${last ? (first ? ' ' + last : last) : ''}`;

  return {
    firstName,
    lastName,
    fullName,
    initials,
  };
};

export const mapUsState = (p: ApiUsStateResponse): UsState => ({ value: p.lookupCode, name: p.lookupDescription });

export const mapProductGroupHcpcs = (ph: ApiProductGroupHcpcsResponse): ProductGroupHcpcs => ph;

export const mapInsuranceTypeReportGroups = (igs: ApiInsuranceTypeReportGroupsResponse): InsuranceTypeReportGroups =>
  igs;
